import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hotels24actions'
import { getParser } from '../../adapters'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchEasymsH24Categories = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.H24_EASYMS_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsCategories(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.h24_fetchEasymsCategoriesSuccess(getParser(urls.easymsCategories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_fetchEasymsCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий EasyMS произошла ошибка'
            )
        )
}

/** @thunk **/
export const fetchEasymsH24Rates = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.H24_EASYMS_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsRates(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.h24_fetchEasymsRatesSuccess(getParser(urls.easymsRates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_fetchEasymsRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов EasyMS произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/h24Api/h24Easyms.js